// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9066 ? "dc112a36" : chunkId) + "." + {"1385":"2819c14ccc4004bd","2938":"824aff2ae336b7f2","3770":"0aba19bc2a0c1e38","7867":"5cb7074ad12a670c","9066":"939ea1c2ccb052d6"}[chunkId] + ".js";
};